import styled from "styled-components";
import Img from "../../../../../../commons/Img";
import colors from "../../../../../../../styles/colorPalette";

export const Wrapper = styled.div`
  align-items: center;
  justify-content: center;
  padding-top: 50px;
  @media (max-width: 1400px) {
    margin-top: -10px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  padding-bottom: 5px;
`;

export const Title = styled.div`
  font-family: "OpenSansRegular";
  font-style: normal;
  color: ${colors.orange1};
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0.18px;
  @media (max-width: 1400px) {
    font-size: 18px;
    line-height: 22px;
  }
`;

export const HelpIcon = styled(Img)`
  height: 16.67px;
  width: 16.67px;
  margin-left: 5px;
  @media (max-width: 1400px) {
    height: 12.5px;
    width: 12.5px;
  }
`;
